const ProjectStateEnum = {
	Active: 1,
	Trial: 3,
	Blocked: 2,
};

Object.freeze(ProjectStateEnum);

export default ProjectStateEnum;
